import { format } from "date-fns";
import { useWeather } from "@/hooks/useWeather";
import { useAuth } from "@/contexts/AuthContext";
import { useCommandStyle } from "@/contexts/CommandStyleContext";

export function TopBar() {
  const weather = useWeather();
  const { user } = useAuth();
  const { copy } = useCommandStyle();
  const fullName = user?.user_metadata?.full_name || user?.user_metadata?.name || "";
  const firstName = fullName.split(" ")[0] || "OPERATOR";
  const greetingText = copy.greeting.replace("{name}", firstName.toUpperCase());

  return (
    <header className="flex items-center justify-between px-4 py-3 border-b border-border">
      <div>
        <div className="flex items-center gap-2">
          <h1 className="text-lg font-bold uppercase tracking-wide">{greetingText}</h1>
        </div>
        <div className="flex items-center gap-2">
          <p className="text-sm text-muted-foreground">
            {format(new Date(), "EEEE, MMM d")}
          </p>
          {weather && (
            <span className="text-sm text-muted-foreground">
              &middot; {weather.temp}°F &middot; {weather.condition}
            </span>
          )}
        </div>
      </div>
    </header>
  );
}
